(function () {
  'use strict';

  function disableSnap() {
    var root = document.documentElement;
    root.classList.remove(
      'nx-chapter-snap-enabled',
      'nx-chapter-snap-desktop-mandatory',
      'nx-chapter-snap-desktop-proximity',
      'nx-chapter-snap-mobile-mandatory',
      'nx-chapter-snap-mobile-proximity'
    );

    document.querySelectorAll('.shopify-section').forEach(function (sectionEl) {
      sectionEl.classList.remove(
        'nx-chapter-snap-target',
        'nx-chapter-snap-target--last',
        'nx-chapter-snap-none'
      );
    });

    document.querySelectorAll('.nx-editorial-hero[data-nx-text-fade="true"]').forEach(function (hero) {
      hero.classList.add('is-text-visible');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableSnap);
  } else {
    disableSnap();
  }

  document.addEventListener('shopify:section:load', disableSnap);
  document.addEventListener('shopify:section:reorder', disableSnap);
})();
